// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-389b10e1] .callout-extended .overflow-hidden {\n  overflow: unset !important;\n}\n@media only screen and (max-width: 768px) {\n.row-container .status[data-v-389b10e1] {\n    border-right: unset !important;\n}\n}", ""]);
// Exports
module.exports = exports;
